export default {
    login: async function (params) {
        let option = {
            url: '/api/v1/partner/login',
            type: 'post',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    oneKeeperLogin: async function (params) {
        let option = {
            url: '/api/v1/superviser/login',
            type: 'post',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    }
}